import { Outlet } from 'react-router-dom';
import { RouteErrorBoundary } from '@/components/ui/RouteErrorBoundary';
import { PhoneNav } from './PhoneNav';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

/**
 * Shell per device class:
 * - phone (<md): slim top bar + floating bottom tab bar with a More sheet
 *   (PhoneNav); tinted canvas; <main> padded by --m-tab-bar-h.
 * - tablet/desktop (md+): 76px collapsed rail that overlays (never pushes) when expanded.
 * Direction comes from <html dir>, so only logical utilities are used here —
 * no reversing the row on direction.
 */
export function AppLayout(): JSX.Element {
    return (
        <div className="flex h-dvh bg-[var(--m-canvas)] text-tg-ink md:bg-tg-page">
            <Sidebar />
            {/* The rail is fixed and overlays when expanded, so it takes no flow
                width. Reserve its 76px resting width (md+ only, where it exists). */}
            <div className="flex min-w-0 flex-1 flex-col overflow-hidden md:ps-[76px]">
                <TopBar />
                <main
                    id="main-content"
                    className="min-w-0 flex-1 overflow-y-auto overflow-x-hidden px-4 pb-[calc(var(--m-tab-bar-h)+1rem)] pt-4 sm:px-6 sm:pt-6 md:pb-[max(1.5rem,var(--pa-safe-bottom))] lg:px-7 lg:[@media(max-height:800px)]:pt-4"
                >
                    <div className="mx-auto w-full min-w-0 max-w-[1680px]">
                        <RouteErrorBoundary>
                            <Outlet />
                        </RouteErrorBoundary>
                    </div>
                </main>
            </div>
            <PhoneNav />
        </div>
    );
}
